/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReferralCode } from './ReferralCode';
import {
    ReferralCodeFromJSON,
    ReferralCodeFromJSONTyped,
    ReferralCodeToJSON,
    ReferralCodeToJSONTyped,
} from './ReferralCode';

/**
 * 
 * @export
 * @interface PostChallengeSlugReferralsOwnCodeResponse
 */
export interface PostChallengeSlugReferralsOwnCodeResponse {
    /**
     * 
     * @type {ReferralCode}
     * @memberof PostChallengeSlugReferralsOwnCodeResponse
     */
    referralCode: ReferralCode;
}

/**
 * Check if a given object implements the PostChallengeSlugReferralsOwnCodeResponse interface.
 */
export function instanceOfPostChallengeSlugReferralsOwnCodeResponse(value: object): value is PostChallengeSlugReferralsOwnCodeResponse {
    if (!('referralCode' in value) || value['referralCode'] === undefined) return false;
    return true;
}

export function PostChallengeSlugReferralsOwnCodeResponseFromJSON(json: any): PostChallengeSlugReferralsOwnCodeResponse {
    return PostChallengeSlugReferralsOwnCodeResponseFromJSONTyped(json, false);
}

export function PostChallengeSlugReferralsOwnCodeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostChallengeSlugReferralsOwnCodeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'referralCode': ReferralCodeFromJSON(json['referralCode']),
    };
}

export function PostChallengeSlugReferralsOwnCodeResponseToJSON(json: any): PostChallengeSlugReferralsOwnCodeResponse {
    return PostChallengeSlugReferralsOwnCodeResponseToJSONTyped(json, false);
}

export function PostChallengeSlugReferralsOwnCodeResponseToJSONTyped(value?: PostChallengeSlugReferralsOwnCodeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referralCode': ReferralCodeToJSON(value['referralCode']),
    };
}

